<template>

    <b-modal
        id="element-changelog-modal"
        :title="'Zobacz changelog dla ' + (element ? element.display_name : null)"
        ok-only
        ok-title="Zamknij"
        ok-variant="secondary"
        no-close-on-backdrop
        @hidden="elementChangelogModalHandleHide">
        <div v-if="element">
            <div>Element: {{ element.display_name }} ({{ element.type === 'game' ? 'gra' : (element.type === 'menu' ? 'menu' : '---') }})</div>
            <br>
            <br>
            <div class="mb-2" style="font-size: 0.875rem;">Changelog</div>
            <pre>{{ element.changelog }}</pre>
        </div>
    </b-modal>

</template>

<script>

    export default {

        name: 'GameLibraryElementChangelogModal',

        props: [
            'repo'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                element: null
            }
        },

        mounted() {

            this.eventHub.$on('game-library-show-element-changelog' , (type, element) => {
                this.eventHub.$emit('processing-start');
                this.element = {
                    type: type,
                    id: element.id,
                    display_name: element.display_name,
                    changelog: null
                };
                if (type === 'game') {
                    axios.get(route('game::game-library.get-game-changelog', {repo: this.repo, id: this.element.id}))
                        .then(response => {
                            this.element.changelog = response.data.data.changelog;
                            this.eventHub.$emit('processing-finish');
                            this.$bvModal.show('element-changelog-modal');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                        });
                } else if (type === 'menu') {
                    axios.get(route('game::game-library.get-menu-changelog', {repo: this.repo}))
                        .then(response => {
                            this.element.changelog = response.data.data.changelog;
                            this.eventHub.$emit('processing-finish');
                            this.$bvModal.show('element-changelog-modal');
                        })
                        .catch(error => {
                            console.log(error);
                            this.eventHub.$emit('processing-finish');
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                        });
                } else {
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                }
            });
        },

        methods: {

            elementChangelogModalHandleHide() {
                this.element = null;
            }

        }

    }

</script>
